export const moduleState = {
  managers: [],
  loading: false,
  error: null,
};

export const getters = {
  managers: state => state.managers,
  loading: state => state.loading,
  error: state => state.error,
  hasManagers: state => state.managers.length > 0,
};

export const mutations = {
  SET_MANAGERS(state, managers) {
    state.managers = managers || [];
    state.error = null;
  },
  SET_LOADING(state, loading) {
    state.loading = loading;
  },
  SET_ERROR(state, error) {
    state.error = error;
  },
};

export const actions = {
  async getFundingManagers({ commit, dispatch, rootState }, { clientId }) {
    const recipientClientId = clientId || rootState.client?.client?.id;

    if (!recipientClientId) {
      commit('SET_ERROR', 'Client ID not available');
      return [];
    }

    const response = await dispatch(
      'request/get',
      {
        url: `/api/bulkfunding/recipient/${recipientClientId}/managers`,
        errorMessage: 'Failed to load funding managers',
        loadingMutation: 'fundingManagers/SET_LOADING',
      },
      { root: true }
    );

    if (!response) {
      // Error already handled by request module
      return [];
    }

    commit('SET_MANAGERS', response.data);
    return response.data;
  },
};
